import { useEffect, useState } from "react";

/**
 * useIsPreviewTab — is this browser tab a coordinator's disposable preview?
 *
 * A coordinator opens the caregiver pages in a new tab ("Preview as caregiver
 * ↗", "Preview ↗", "View ↗"); those links carry ?preview=1. The tab remembers
 * it in sessionStorage — per tab, so following links inside the preview keeps
 * it a preview and a real caregiver's tab is never one — and the pages swap
 * their breadcrumb for PreviewBanner, whose only exit is closing the tab.
 * (Plan G lost the wiring; restored Oct 11.) ?preview=true is the player's
 * own draft-preview mode and also marks the tab.
 */
const KEY = "cg.previewTab";

export function useIsPreviewTab() {
  const [isPreview, setIsPreview] = useState(() => read());
  useEffect(() => {
    try {
      const p = new URLSearchParams(window.location.search).get("preview");
      if (p && p !== "0" && p !== "false") {
        window.sessionStorage.setItem(KEY, "1");
        setIsPreview(true);
      }
    } catch { /* storage blocked: the URL alone decides this page */ }
  }, []);
  return isPreview;
}

function read() {
  try {
    if (window.sessionStorage.getItem(KEY) === "1") return true;
    const p = new URLSearchParams(window.location.search).get("preview");
    return !!p && p !== "0" && p !== "false";
  } catch { return false; }
}
